import { render, staticRenderFns } from "./AmazonSellerData.vue?vue&type=template&id=36d99ad5"
import script from "./AmazonSellerData.vue?vue&type=script&lang=js"
export * from "./AmazonSellerData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports